import React, { useMemo } from 'react'
import HotelPageCategoryTile from './HotelPageCategoryTile'
import { CategoryData } from './types'
import { generateCategorySearchUrl } from 'lib/url/searchUrlUtils'

interface Props {
  category: CategoryData
}

function HotelPageSearchHotelCategoryTile(props: Props) {
  const { category } = props

  const categorySearchUrl = useMemo(() => generateCategorySearchUrl({
    parameterName: category.parameterName,
    parameterValue: category.parameterValue,
  }), [category])

  return <HotelPageCategoryTile
    toUrl={categorySearchUrl}
    category={category}
    actionText="View offers"
  />
}

export default HotelPageSearchHotelCategoryTile
